import React from 'react';
import {marked} from 'marked';

/**
 * Parse markdown text
 * @param {string} text
 * @return {html}
 */
export function renderMarkdown(text) {
	if (text && typeof text === 'string' && text.length > 0) {
		const html = marked.parse(text);
		return <div dangerouslySetInnerHTML={{__html: html}} />;
	}
	return <div />;
}

export function getText(text, languageId) {
	if (typeof text === 'object') {
		if (!!languageId) {
			if (languageId in text) {
				return text[languageId];
			} else if ('da' in text) {
				console.error('Text is missing translation for languageId ' + languageId +
					' - falling back on danish text.');
				return text['da'];
			}
			console.error('Text is missing translation for languageId ' + languageId);
			console.log(text);

		} else {
			console.error('No language id given');
		}
	} else {
		if (!!languageId) {
			console.error('Text is missing translation for languageId ' + languageId);
			console.log(text);
		} else {
			return text;
		}
	}
}